<template>
  <Layout footer>
    <div class="app-container text-base">
      <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
        <span class="mr-1">当前位置：</span>
        <NBreadcrumb>
          <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
          <NBreadcrumbItem>网创培训</NBreadcrumbItem>
        </NBreadcrumb>
      </div>
      <img class="carousel-img" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/banner4.png" />
      <div class="flex items-center my-4 zhu_yi">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/news.png" alt="" />
        <span class="mx-2 text-base font-bold">注意事项：</span>
        <span style="color: #f70707">
          学员账号默认不开通网创培训课程和实训，如需学习和实训请联系服务人员进行开通。
        </span>
      </div>
      <p class="mt-10 text-gray-600">
        学员通过网创平台进行网创培训，落实网络创业培训。平台提供虚拟商城、实训等功能，学员通过真实体验网络开
        店全过程，熟悉网络开店过程，掌握网络开店必要条件，最终提升网店专业化运营能力。
      </p>
      <img class="mt-8" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/bg3.png" alt="" />
      <div class="pl-16 pb-20">
        <p class="mt-6 text-gray-600">网络创业培训在线辅助平台，体验真实的开店全过程。</p>
        <div class="relative mt-10 text-gray-600">
          <img style="top: 4px; left: -34px" class="absolute"
            src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/step-3.png" alt="" />
          <div>
            <p style="color: #eb5d26">开办网店：</p>
            <p class="mt-1">模拟网店申请流程，让学员了解开办网店的所需材料。</p>
          </div>
          <div class="mt-11">
            <p style="color: #eb5d26">建立交易体系：</p>
            <p class="mt-1">通过建立收款账号、运费模板、退货退款等让学员了解电商交易流程。</p>
          </div>
          <div class="mt-11">
            <p style="color: #eb5d26">网店铺货：</p>
            <p class="mt-1">通过网店铺货，让学员了解电商货源渠道，产品选择及快速完成网店铺货。</p>
          </div>
          <div class="mt-11">
            <p style="color: #eb5d26">网店装修设计：</p>
            <p class="mt-1">
              让学员优化网店装修，来了解网店装修的设计模板，以便更好、更快装修网店，提高网店装修效率。
            </p>
          </div>
          <div class="mt-12">
            <p style="color: #eb5d26">网店管理推广优化：</p>
            <p class="mt-1">
              让学员了解如何进项网店管理推广，如何优化标题、如何进行推广，以加强学员网店管理推广能力。
            </p>
          </div>
        </div>
      </div>
      <img class="block w-full object-cover" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/detail-3.png"
        alt="" />
    </div>
  </Layout>
</template>

<script setup>
import Layout from '@/components/Layout';
import { useRouter } from 'vue-router';

const router = useRouter();
function gotoHome () {
  router.push('/');
}
</script>

<style lang="scss" scoped>
.carousel-img {
  display: block;
  width: 100%;
  height: 410px;
  object-fit: cover;
}
:deep(.n-breadcrumb-item) {
  font-size: 16px;
}
.zhu_yi {
  border: 1px dashed #f39a1d;
  height: 60px;
  font-size: 20px;
}
</style>
